import React, {PureComponent} from 'react';
import {Col, Container, Row, Card, CardBody, Button, ButtonToolbar} from 'reactstrap';
import LogInForm from './components/LogInForm';
import {Link} from 'react-router-dom';
import * as TextManager from '../../modules/languages/TextManager';

const icon = `${process.env.PUBLIC_URL}/img/logo.png`;


export default class LogIn extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div className='account'>
                <div className='account__wrapper'>
                    <div className='account__card'>
                        <h4 className='account__text' style={{textAlign: 'center', color: '#70bbfd'}}>Welcome to</h4>
                        <img src={icon}/>
                        <LogInForm changeUserName={(username) => this.changeUserName(username)}
                                   changePassword={(password) => this.changePassword(password)} onSubmit/>
                        {/*<div className='account__or'>ליצירת קשר חנן יעקובוביץ - 0504433915
                        </div>*/}
                        <div className='account__or'>
                            <div style={{
                                color: "black",
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '15px',
                                textAlign: 'center'
                            }}>
                                <a className={"about-simple"} href={"https://www.s-romi.co.il/%d7%a6%d7%95%d7%a8-%d7%a7%d7%a9%d7%a8-1/"} target={"_blank"}
                                   style={{
                                       color: "black",
                                       fontStyle: "italic",
                                       borderRadius: "8px",
                                       backgroundColor: "#70bbfd"

                                   }}>ליצירת קשר</a>
                            </div>
                        </div>
                        <div style={{
                            color: "black",
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '25px',
                            textAlign: 'center'
                        }}>
                            <a className={"about-simple"} href={"http://www.s-romi.co.il"} target={"_blank"}
                               style={{
                                   color: "black",
                                   fontStyle: "italic",
                                   borderRadius: "8px",
                                   backgroundColor: "#70bbfd"

                               }}>אודות ש.רומי יזמות ושיווק בע"מ</a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}